module.exports = __webpack_public_path__ + "static/media/gsuite.3eae5483.png";